import Vue from 'vue';

Vue.filter('stripeHttp', function (value) {
    value = value.replace('http://', '');
    value = value.replace('https://', '');
    return value;
})
Vue.filter('striphtml', function (value) {
    var div = document.createElement("div");
    div.innerHTML = value;
    var text = div.textContent || div.innerText || "";
    return text;
});
Vue.filter('replaceUnderscore', function (value) {
    value = value.replace('_', ' ');
    return value;
});
Vue.directive('expand',  {
    inserted: function (el) {
        el.focus()
    }
});
Vue.filter('removeHttp', function (string) {
    string = string.replace('http://', '');
    string = string.replace('https://', '');
    return string;
})
